import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#4e342e',
    }
  },
  overrides: {
    MuiOutlinedInput: {
        root: {
            position: 'relative',
            borderColor: '#ebdcc4',
            '& $notchedOutline': {
                borderColor: '#ebdcc4',
            },
            '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
                borderColor: '#ebdcc4',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    borderColor: '#ebdcc4',
                },
            },
            '&$focused $notchedOutline': {
                borderColor: '#ebdcc4',
                borderWidth: 1,
            },
        },
    },
    MuiFormLabel: {
        root: {
            '&$focused': {
                color: '#4A90E2'
            }
        }
    },
    MuiToolbar: {
      regular: {
        height: "64px",
        minHeight: "64px",
        '@media(min-width:600px)' : {
          minHeight:"48px",
          paddingLeft: '0px',
          paddingRight: '0px',
        }
      },
      gutters: {
          paddingLeft: '0px',
          paddingRight: '0px',
      },
    }
  },
});